import { FC, useState } from 'react';
import { Box, BoxProps, chakra, Image, useMultiStyleConfig } from '@chakra-ui/react';

import { UserLogoComponentName } from '../theme';
import { usePropChange } from '@netiva/classifieds-common';

const Container = chakra(Box, {
  baseStyle: {},
});

export type UserLogoProps = BoxProps & {
  src?: string;
  alt?: string;
  fallback?: React.ReactElement;
  showOnError?: boolean;
  onLoaded?: (success: boolean) => void;
};

export const UserLogo: FC<UserLogoProps> = (props) => {
  const { src, alt, fallback, display, showOnError, onLoaded, ...rest } = props;

  const styles = useMultiStyleConfig(UserLogoComponentName, props);

  const [isLoaded, setIsLoaded] = useState(false);

  if (usePropChange(src)) {
    setIsLoaded(false);
  }

  const handleLoad = () => {
    setIsLoaded(true);
    if (onLoaded) {
      onLoaded(true);
    }
  };

  const handleError = () => {
    setIsLoaded(false);
    if (onLoaded) {
      onLoaded(false);
    }
  };

  if (!src) {
    return null;
  }

  return (
    <Container sx={styles.container} {...rest} display={isLoaded || showOnError ? display || 'block' : 'none'}>
      <Image
        sx={styles.image}
        src={src}
        alt={alt || 'Logo'}
        onLoad={handleLoad}
        onError={handleError}
        fallback={fallback || <></>}
        fallbackStrategy="onError"
      />
    </Container>
  );
};
